export const trackWithPixel = (event, data) => {
  if (window.fbq) {
    if (event === "Lead") {
      window.fbq("track", "Lead");
    } else {
      window.fbq("trackCustom", event, data);
    }
  }
};
